import React, { ReactNode, useEffect, useState } from "react";

import "./speechBubble.css";

interface SpeechBubbleProps {
    position: SpeechBubblePosition;
    text: string;
    icon: ReactNode;
    ref?: any;
}

class SpeechBubblePosition {
    x: number;
    y: number;
    orientation: SpeechBubbleOrientation;

    constructor(x: number, y: number, orientation: SpeechBubbleOrientation) {
        this.x = x;
        this.y = y;
        this.orientation = orientation;
    }
}

enum SpeechBubbleOrientation {
    LEFT, CENTER, RIGHT
}

export default function SpeechBubble(props: SpeechBubbleProps) {

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if(props.text == undefined || props.text == "") {
            setOpen(false);
        }else {
            setOpen(true);
        }
    }, [props.text]);

    var orientation = props.position.orientation;
    var posX = props.position.x - (props.ref.current?.offsetWidth / 2);
    if(posX < 0) {
        orientation = SpeechBubbleOrientation.LEFT;
        posX = props.position.x - (props.ref ? props.ref.current?.parentElement.offsetWidth/2 : 0);
    }

    return <div ref={props.ref} className={"speech-bubble " + SpeechBubbleOrientation[orientation].toLowerCase() + (open ? " open" : "")} style={{
        left: posX,
        top: props.position.y + 20
    }}>
        <span>{props.icon}</span>
        <a className="info">{props.text}</a>
    </div>;

}

export {SpeechBubbleOrientation, SpeechBubblePosition}